/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { DialogActions, Tab, Tabs } from "@mui/material";
import { LinkEditContext } from "cms/links/link-selector/context/edit";

const LinkEditDialogTopActions = () => {
    
    const {
        selectedTab,
        handleTabsChange,
    } = useContext(LinkEditContext);

    const placementCount = 0;
    const placementCountTemplate = `Placements (${placementCount})`;

    return (
        <Fragment>
            <DialogActions
                className="simplicity-link-selector-window-tabs"
            >
                <Tabs
                    value={selectedTab}
                    onChange={handleTabsChange}
                    aria-label="edit tabs"
                >
                    <Tab
                        label="Properties"
                        id='tabpanel-1'
                        aria-controls='tabpanel-1'
                    />
                    <Tab
                        label={placementCountTemplate}
                        id='tabpanel-2'
                        aria-controls='tabpanel-2'
                    />
                </Tabs>
            </DialogActions>
        </Fragment>
    );
};

export { LinkEditDialogTopActions };
